module.exports = __webpack_public_path__ + "nhl_icon.embedded.svg?aa74b50e38faf3fe13abfbbc2f2d657d";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images/nhl_icon.embedded.svg
// module id = 1328
// module chunks = 37